import React, { ReactNode } from 'react';
import Box from 'components/elements/Box';

import { ReactComponent as Close } from 'icons/icon-close.svg';
import H1 from 'components/elements/h1';
import {
  RejectedMessage,
  ModalCloseButton,
  ListViewContentWrapper,
} from '../shared/styles';

interface IListModalContainerProps {
  close: () => void;
  title: string;
  rejectedMessage: string | undefined;
  children: ReactNode;
}

const ListViewContainer: React.FC<IListModalContainerProps> = (props) => {
  const { close, title, rejectedMessage, children } = props;

  return (
    <Box m={0} p={0} pt={1} pb={3}>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignContent="stretch"
        alignItems="flex-end"
      >
        <ModalCloseButton
          data-inviewbutton
          onClick={close}
          alignSelf="auto"
          marginLeft="auto"
        >
          <Close />
        </ModalCloseButton>
      </Box>

      <ListViewContentWrapper>
        <Box mb={6}>
          <H1 fontSize={4}>{title}</H1>
          {rejectedMessage && (
            <RejectedMessage>{rejectedMessage}</RejectedMessage>
          )}
        </Box>
        {children}
      </ListViewContentWrapper>
    </Box>
  );
};

export default ListViewContainer;
